import { Box } from '@cmg/design-system';
import React from 'react';

/**
 * The client's own name, embedded in our copy. It is publisher-supplied and validated only for
 * length and dangerous characters, so a name can be written to read as a sentence — "Foo, already
 * approved by your admin". Our words around it are dimmed and the name is not, which is a boundary
 * the string itself cannot forge: weight alone does not work, since h3 is already bold.
 *
 * It also opts out of the theme's `capitalize` on h1-h4 — restyling someone else's name would
 * misrepresent it.
 */
export const ClientName: React.FC<{ name: string }> = ({ name }) => (
  <Box
    component="span"
    sx={{ textTransform: 'none', wordBreak: 'break-word', color: 'common.white' }}
  >
    {name}
  </Box>
);

export default ClientName;
